import {Time} from 'yougile-util'
import {Hub} from 'yougile-model'
import {archiveAllowed} from '@client/hub-actions-allowed'
import {Sync} from '@client/sync'
import {Column} from '@extensions/column'

export const updateWhenTaskDone = (task: Hub): void => {
  if (!task?.location) {
    return
  }

  const box = Sync.getCurrentSandbox()
  const column = box.getHub(task.location)
  if (!column?.location) {
    return
  }

  const board = box.getHub(column.location)

  const settings = board?.data?.settings

  const data = settings?.moveTaskToColWhenDone

  if (task?.data?.gtd?.state?.stage !== 'done') {
    return
  }

  if (data?.checked && data?.value) {
    const toColumn = box.getHub(data.value)
    if (!toColumn || toColumn.deleted) {
      return
    }

    Column.taskDropHandler(0, task, toColumn, {
      ignoreBoardFilters: true,
      type: 'automatic'
    })
  }

  if (archiveAllowed(task.id) && settings?.autoCompleteTasks) {
    task.complete = Time.now()
    task.commit()
  }
}
